// *******************************************************************************
// Map Module
// *******************************************************************************

const mapModule = document.querySelectorAll('.sc-map-module');

if (mapModule.length > 0) {
  let mapImageEle = null;

  const initMapImageScrollMagic = () => {
    mapImageEle = new ScrollMagic.Controller();

    mapModule.forEach((ele) => {
      const stickyElem = ele.querySelector('.map-module__sticky');
      const imageElem = ele.querySelector('.map-module__map');
      const marketListItems = ele.querySelectorAll('.map-module__market');

      const mapItemsTween = gsap.timeline();

      mapItemsTween
        .to(imageElem, {
          width: windowWidth() >= 1440 ? '1440px' : 'calc(100vw - 40px)',
          height: windowWidth() >= 1440 ? '740px' : '70vh',
          // markers: true,
        })
        .to(marketListItems, {
          top: 0,
          opacity: 1,
          stagger: 0.05,
          yoyo: true,
        });

      new ScrollMagic.Scene({
        triggerElement: stickyElem,
        duration: stickyElem.clientHeight,
        triggerHook: 0.6,
      })
        // .addIndicators({ name: 'Image' })
        .setTween(mapItemsTween)
        .addTo(mapImageEle);
    });
  };

  if (windowWidth() >= breakpointMd) {
    initMapImageScrollMagic();
  }

  const toggleByDataAttribute = ({ dataAttr, activeClass, hoverBreakpoint = breakpointMd, defaultValue = null }) => {
    const elements = document.querySelectorAll(`[${dataAttr}]`);

    elements.forEach((ele) => {
      const parentEle = ele.closest('.map-module');
      if (!parentEle) return;

      const activate = () => {
        const targetValue = ele.getAttribute(dataAttr);

        parentEle.querySelectorAll(`[${dataAttr}]`).forEach((item) => {
          item.classList.toggle(activeClass, item.getAttribute(dataAttr) === targetValue);
        });
      };

      const reset = () => {
        parentEle.querySelectorAll(`[${dataAttr}]`).forEach((item) => {
          const isDefault = defaultValue !== null && item.getAttribute(dataAttr) === defaultValue;

          item.classList.toggle(activeClass, isDefault);
        });
      };

      if (windowWidth() >= hoverBreakpoint) {
        // DESKTOP (hover)
        ele.addEventListener('mouseenter', activate);
        ele.addEventListener('mouseleave', reset);
      } else {
        // MOBILE (tap)
        ele.addEventListener('click', activate);
      }
    });
  };

  /* ============================
   Toggle Map Area
============================ */
  toggleByDataAttribute({
    dataAttr: 'data-market',
    activeClass: 'is-active',
    defaultValue: 'domestic',
  });

  /* ============================
   Toggle Region
============================ */
  toggleByDataAttribute({
    dataAttr: 'data-region',
    activeClass: 'is-hovered',
  });
}
